// src/api.ts

import axios from 'axios';

// Use environment variable for API base URL
const agentsApiBaseUrl = process.env.REACT_APP_BLEND_AGENTS_API_URL;

// Create an Axios instance
const agentApi = axios.create({
    baseURL: agentsApiBaseUrl, // Use the API URL from environment variables
    headers: {
        'Content-Type': 'application/json',
    },
    // You can set other defaults like timeout or authorization headers here as well
    timeout: 300000,
});

export default agentApi;

// Create an Axios instance
const agentApiToken = axios.create({
    baseURL: agentsApiBaseUrl, // Use the API URL from environment variables
    headers: {
        'Content-Type': 'application/json',
    },
    // You can set other defaults like timeout or authorization headers here as well
    timeout: 300000,
});

const agentFormApiToken = axios.create({
    baseURL: agentsApiBaseUrl, // Use the API URL from environment variables
    headers: {
        'Content-Type': 'multipart/form-data',
    },
    // You can set other defaults like timeout or authorization headers here as well
    timeout: 300000,
});


// Add an interceptor to include the token before each request
agentApiToken.interceptors.request.use(
    (config: any) => {
        config.headers['Authorization'] = `Bearer ${process.env.REACT_APP_AGENTS_API_KEY}`;
        return config;
    },
    (error: any) => {
        // Handle errors in the request setup
        return Promise.reject(error);
    }
);

agentFormApiToken.interceptors.request.use(
    (config: any) => {
        config.headers['Authorization'] = `Bearer ${process.env.REACT_APP_AGENTS_API_KEY}`;
        return config;
    },
    (error: any) => {
        // Handle errors in the request setup
        return Promise.reject(error);
    }
);

export { agentApiToken, agentFormApiToken };
